import Datatable from "../../Components/Datatable"
import React, { useEffect, useState } from "react";
import axios from "axios";
import { EXPRESS_BASE_URL } from "../../../../../Helpers/apiConfig";

// schoolid'si 0 olan (okul/kurumsal degil, bireysel) StudentResponsibility
// kayitlarinin listesi. type: 0 = Kendisi, 1 = Velayeti/Vesayeti Altinda.
export const AdminGuardianList = () => {
    const [data, setData] = useState([]);
    const [msg, setMsg] = useState("");
    const [loading, setLoading] = useState(true);

    const columns = React.useMemo(
        () => [
            {
                Header: "İsim",
                Footer: "İsim",
                accessor: 'name',
            },
            {
                Header: "E-posta",
                Footer: "E-posta",
                accessor: 'email',
            },
            {
                Header: "Üyelik Türü",
                Footer: "Üyelik Türü",
                accessor: 'typeText',
            },
            {
                Header: "Tarih",
                Footer: "Tarih",
                accessor: 'tarihText',
            },
        ],
        [],
    )

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Access-Control-Allow-Origin': '*',
                };
                const res = await axios({
                    method: 'get',
                    url: `${EXPRESS_BASE_URL}/getstudentresponsibilities`,
                    headers: headerss
                });

                const rows = Array.isArray(res.data) ? res.data : [];
                const filtered = rows
                    .filter((row) => Number(row.schoolid) === 0)
                    .map((row) => {
                        const tarihDate = row.tarih ? new Date(row.tarih) : null;
                        return {
                            name: row.name,
                            email: row.email,
                            typeText: Number(row.type) === 1 ? "Velayeti/Vesayeti Altında olan Çocuk" : "Kendisi",
                            tarihText: tarihDate ? tarihDate.toLocaleString("tr-TR") : "-",
                        };
                    });
                setData(filtered);
            } catch (err) {
                setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
            }
            setLoading(false);
        };
        fetchData();
    }, []);

    return (
        <div>
            <div style={{ textAlign: "center" }}>
                <h1>Velayet</h1>
            </div>
            <h4>{msg}</h4>
            {loading && <div>Veriler Yükleniyor!</div>}

            {!loading && (
                <div>
                    <Datatable data={data} columns={columns} tableBaslik="Velayet" />
                </div>
            )}
        </div>
    );
};
export default AdminGuardianList;
